import React from "react";
import { Link } from "react-router-dom";
import { closeModal } from "../../utils";

const Create = () => {
  return (
    <div
      className="create uk-flex-top"
      id="create-modal"
      data-uk-modal="sel-close: uk-modal-close"
    >
      <div className="uk-match-height uk-modal-body uk-modal-dialog uk-margin-auto-vertical">
        <div data-uk-grid className="uk-margin-auto">
          <div
            className="uk-margin-auto uk-padding-remove  uk-modal-close"
            onClick={() => {
              closeModal("create-modal");
            }}
          >
            <Link to="/create-track" className="uk-modal-close">
              <div className="uk-card uk-card-body uk-flex-column uk-flex-center uk-flex">
                <div className="uk-margin-auto">
                  <i className="material-icons-outlined">headset</i>
                </div>
                <div className="uk-margin-small-top">create tracks</div>
              </div>
            </Link>
          </div>
          <div
            className="uk-margin-auto uk-padding-remove uk-modal-close"
            // onClick={() => {
            //   closeModal("create-modal");
            // }}
          >
            <Link
              to="#"
              uk-toggle="target: #album-modal"
              className="uk-modal-close"
            >
              <div className="uk-card uk-card-body uk-flex-column uk-flex-center uk-flex">
                <div className="uk-margin-auto">
                  <i className="material-icons-outlined">album</i>
                </div>
                <div className="uk-margin-small-top">create album</div>
              </div>
            </Link>
          </div>
          <div className="uk-margin-auto uk-padding-remove uk-modal-close">
            <Link
              to="#"
              className=" uk-modal-close"
              uk-toggle="target: #playlists-modal"
            >
              <div className="uk-card uk-card-body uk-flex-column uk-flex-center uk-flex">
                <div className="uk-margin-auto">
                  <i className="material-icons-outlined">playlist_add</i>
                </div>
                <div className="uk-margin-small-top">create playlist</div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Create;
